export default __webpack_public_path__ + "static/media/cookie.ac2a5686.jpg";